import { Component, Input, Output, ViewChild, TemplateRef, Renderer2, ElementRef, OnInit, AfterViewInit, ChangeDetectorRef, EventEmitter } from '@angular/core';
import { debounceTime, fromEvent, throttleTime, Observable } from 'rxjs';
import { Observe } from '../../custom-decorators/Observe';

@Component({
	selector: 'app-tab',
	templateUrl: './tab.component.html',
	styleUrls: ['./tab.component.scss']
})
export class TabComponent implements OnInit, AfterViewInit {
	@Input() public label: string;
	@Input() public active: boolean;
	@Observe("active") active$! : Observable<any>;

	private domElement: HTMLElement;  
  	@ViewChild(TemplateRef) template: TemplateRef<any>;
	@ViewChild("tabContainer") tabContainer : ElementRef;
	rect : any;

	constructor(private renderer: Renderer2, private elementRef: ElementRef,
		private cdr: ChangeDetectorRef) {
		this.domElement = this.elementRef.nativeElement as HTMLElement;	
		
		fromEvent(window, "resize")
		  	.pipe(throttleTime(500), debounceTime(500))
		  	.subscribe(() => this.calculateSize());	
	}

	ngOnInit(): void {
		this.active$?.subscribe({
			next : (isActive : boolean) => {
				if(isActive)
				{
					this.calculateSize();
				}
			},
			error : (ex : Error) => {

			},
			complete : () => {

			}
		});
	}

	ngAfterViewInit(): void {
		//this.calculateSize();
	}

	private calculateSize = () => {		
		if(this.domElement && this.tabContainer)
		{
			const parentRect = this.domElement?.parentElement?.parentElement?.getBoundingClientRect();
			if(parentRect)
			{
				this.rect = { width : parentRect?.width + "px", height : parentRect?.height + "px" };
				this.renderer.setStyle(this.tabContainer?.nativeElement, "height", `${this.rect.height}`);
				this.renderer.setStyle(this.tabContainer?.nativeElement, "width", `${this.rect.width}`);
				this.cdr.detectChanges();
			}			
		}
	}
}
